import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '../../features/auth/context/AuthContext';
import LmsIcsCacheBootstrap from '../../features/calendar/components/LmsIcsCacheBootstrap';
import { ToastProvider } from '../../shared/toast/ToastProvider';

const queryClient = new QueryClient();

export default function AppProviders({ children }) {
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <AuthProvider>
                    <ToastProvider>
                        <LmsIcsCacheBootstrap>{children}</LmsIcsCacheBootstrap>
                    </ToastProvider>
                </AuthProvider>
            </BrowserRouter>
        </QueryClientProvider>
    );
}
